import { render, staticRenderFns } from "./changeOrderDialog.vue?vue&type=template&id=61e70799&"
import script from "./changeOrderDialog.vue?vue&type=script&lang=js&"
export * from "./changeOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./changeOrderDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e70799')) {
      api.createRecord('61e70799', component.options)
    } else {
      api.reload('61e70799', component.options)
    }
    module.hot.accept("./changeOrderDialog.vue?vue&type=template&id=61e70799&", function () {
      api.rerender('61e70799', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/OuterBoxLabelManagement_v2/components/changeOrderDialog.vue"
export default component.exports